<template>
  <div class="d-inline">
    <v-btn
      color="teal"
      dark
      rounded
      class="mr-2"
      :loading="loading"
      @click="exportPresentation"
    >
      <v-icon class="mr-1">mdi-presentation</v-icon>
      Present Performance
    </v-btn>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      timeout="4000"
      top
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { buildPerformancePresentation } from "@/utils/performancePresentation";

export default {
  name: "CompanyPerformanceExport",
  data() {
    return {
      loading: false,
      snackbar: { show: false, text: "", color: "success" },
    };
  },
  computed: {
    ...mapGetters({ user: "auth/user" }),
  },
  methods: {
    ...mapActions({
      get_company_performance: "summary/get_company_performance",
    }),
    notify(text, color = "success") {
      this.snackbar = { show: true, text, color };
    },
    async exportPresentation() {
      if (!this.can("accounting.performance_table")) {
        this.notify(
          "You do not have permission to access this feature.",
          "warning"
        );
        return;
      }

      // Open the window synchronously (inside the click handler) so popup
      // blockers don't intercept it after the async fetch resolves.
      const presentationWindow = window.open("", "_blank");
      if (!presentationWindow) {
        this.notify(
          "Please allow pop-ups for this site to open the presentation.",
          "warning"
        );
        return;
      }
      presentationWindow.document.write(
        "<p style='font-family:sans-serif;padding:24px;color:#555'>Preparing presentation…</p>"
      );

      this.loading = true;
      try {
        const data = await this.get_company_performance();
        const html = buildPerformancePresentation(data);
        presentationWindow.document.open();
        presentationWindow.document.write(html);
        presentationWindow.document.close();
        presentationWindow.focus();
      } catch (err) {
        presentationWindow.close();
        this.notify(
          err.response?.data?.message ||
            "Failed to generate the performance presentation. Please try again.",
          "error"
        );
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.d-inline {
  display: inline-block;
}
</style>
